import produce from "immer";
import { PolicyEmailComposeActions } from ".";
import { IPolicyEmailComposeState } from "./policyEmailCompose.types";
import { initialPolicyEmailComposeState } from "./policyEmailComposeState";
import {
  OPEN_POLICY_EMAIL_PANEL,
  CLOSE_POLICY_EMAIL_PANEL,
  RESET_POLICY_EMAIL_STATE,
  FETCH_RECIPIENT_EMAILS_PROGRESS,
  FETCH_RECIPIENT_EMAILS_SUCCESS,
  FETCH_RECIPIENT_EMAILS_FAILED,
  FETCH_PRODUCER_EMAIL_PROGRESS,
  FETCH_PRODUCER_EMAIL_SUCCESS,
  FETCH_PRODUCER_EMAIL_FAILED,
  SEND_POLICY_EMAIL_PROGRESS,
  SEND_POLICY_EMAIL_SUCCESS,
  SEND_POLICY_EMAIL_FAILED,
} from "./policyEmailComposeActions";

export const policyEmailComposeReducer = (
  state: IPolicyEmailComposeState = initialPolicyEmailComposeState,
  action: PolicyEmailComposeActions,
) => {
  switch (action.type) {
    // --- Panel Open/Close/Reset ---
    case OPEN_POLICY_EMAIL_PANEL: {
      const { customerId, producerCode } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.panelOpen = true;
        draftState.customerId = customerId;
        draftState.producerCode = producerCode;
      });
      return newState;
    }
    case CLOSE_POLICY_EMAIL_PANEL: {
      const newState = produce(state, (draftState) => {
        draftState.panelOpen = false;
      });
      return newState;
    }
    case RESET_POLICY_EMAIL_STATE: {
      return initialPolicyEmailComposeState;
    }

    // --- Recipient Email Loading ---
    case FETCH_RECIPIENT_EMAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.recipientLoading = true;
        draftState.error = null;
      });
      return newState;
    }
    case FETCH_RECIPIENT_EMAILS_SUCCESS: {
      const { emails } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recipientLoading = false;
        draftState.recipientEmails = emails;
      });
      return newState;
    }
    case FETCH_RECIPIENT_EMAILS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recipientLoading = false;
        draftState.recipientEmails = [];
      });
      return newState;
    }

    // --- Producer Email Loading ---
    case FETCH_PRODUCER_EMAIL_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.producerEmailLoading = true;
        draftState.error = null;
      });
      return newState;
    }
    case FETCH_PRODUCER_EMAIL_SUCCESS: {
      const { email } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.producerEmailLoading = false;
        draftState.producerEmail = email;
      });
      return newState;
    }
    case FETCH_PRODUCER_EMAIL_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.producerEmailLoading = false;
      });
      return newState;
    }

    // --- Sending Email ---
    case SEND_POLICY_EMAIL_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sendingEmail = true;
        draftState.error = null;
      });
      return newState;
    }
    case SEND_POLICY_EMAIL_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.sendingEmail = false;
      });
      return newState;
    }
    case SEND_POLICY_EMAIL_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sendingEmail = false;
        draftState.error = error;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
